import React, { useState } from 'react'

import { EuiCheckbox, EuiComboBox, EuiFormRow, EuiSpacer } from '@elastic/eui'
import { EuiComboBoxOptionOption } from '@elastic/eui/src/components/combo_box/types'

import { AudienceFootprint } from 'api/interfaces'
import { useGetRegionsQuery } from 'api/rtkQueryApi/platform/targetingApi'

export const emptyFootprint = (): AudienceFootprint => ({ states: [], citiesByState: {} })

export const hasFootprint = (footprint: AudienceFootprint | null | undefined) => !!footprint && footprint.states.length > 0

export interface FootprintSelectorProps {
  value: AudienceFootprint
  onChange: (value: AudienceFootprint) => void
}

export const FootprintSelector: React.FC<FootprintSelectorProps> = ({ value, onChange }) => {
  const regionsQuery = useGetRegionsQuery({})

  const stateOptions: EuiComboBoxOptionOption<string>[] = (regionsQuery.data ?? []).map(region => ({ label: region.name, value: region.code.toUpperCase() }))
  const selectedStateOptions = stateOptions.filter(option => value.states.includes(option.value as string))

  const onStatesChange = (options: EuiComboBoxOptionOption<string>[]) => {
    onChange({ states: options.map(option => option.value as string), citiesByState: {} })
  }

  return <EuiComboBox placeholder='Select states' options={stateOptions} selectedOptions={selectedStateOptions} isLoading={regionsQuery.isFetching} onChange={onStatesChange} fullWidth />
}

export interface FootprintFormRowProps {
  value: AudienceFootprint
  onChange: (value: AudienceFootprint) => void
}

export const FootprintFormRow: React.FC<FootprintFormRowProps> = ({ value, onChange }) => {
  const [enabled, setEnabled] = useState(hasFootprint(value))
  const isEnabled = enabled || hasFootprint(value)

  const onToggle = (checked: boolean) => {
    setEnabled(checked)
    if (!checked) {
      onChange(emptyFootprint())
    }
  }

  return (
    <EuiFormRow label='Footprint' helpText='Only audience addresses inside the footprint states will be targeted' fullWidth>
      <React.Fragment>
        <EuiCheckbox id='audienceFootprintEnabled' label='Limit the audience to a footprint' checked={isEnabled} onChange={event => onToggle(event.target.checked)} />
        {isEnabled && (
          <React.Fragment>
            <EuiSpacer size='s' />
            <FootprintSelector value={value} onChange={onChange} />
          </React.Fragment>
        )}
      </React.Fragment>
    </EuiFormRow>
  )
}
